<template lang="pug">
  .page-container
    Toolbar
    .app-breadcrumbs.center-breadcrumbs
      v-container.breadcrumbs-container.center-container
        img.breadcrumbs-logo(src="../../assets/logo.png")/
        v-breadcrumbs(:items="breadcrumbs")
          template(slot="item" slot-scope="props")
            router-link(
              :to="props.item.to"
              class="app-breadcrumbs__item"
            ) {{ props.item.text }}

    v-container(v-if='!isLoading')
      v-layout.good-container
        v-flex
          v-layout(row wrap)
            v-flex(xs3 pa-3 :key="index" v-for='(item, index) in goodsCartList' @click.stop="detail(item)")
              v-card.good-item(flat)
                .cover-container
                  .good-number(v-if='item.num') {{item.num}}
                  v-img.cover(:src="item.cover" aspect-ratio="1.5")
                  img.icon-split(src="../../assets/shap-small.png")
                v-card-title
                  div.good-title {{ item.spuName }}
                  div.good-price € {{ item.price }} {{ item.unit }}
                v-card-actions
                  div(v-if='item.num')
                    v-btn(fab small color='secondary' :loading='minsLoading && (checkedSpuId == item.spuId)' @click.stop="handleEditCart(item.skuId, -1, item)")
                      v-icon remove

                  div(v-if='item.num')
                    v-btn(fab small color='secondary' :loading='plusLoading && (checkedSpuId == item.spuId)' @click.stop="handleEditCart(item.skuId, 1, item)")
                      v-icon add

                  div(v-if='!item.num')
                    v-menu(offset-y top origin="center center" transition="scale-transition")
                      template(v-slot:activator="{ on }")
                        v-btn(fab small color='secondary' v-on="on" :loading='plusLoading && (checkedSpuId == item.spuId)' @click.stop="handleCheckedGood(item)")
                          v-icon add
                      v-list
                        v-list-tile
                          v-list-tile-title {{ $t("series.chooseSku") }}
                        v-list-tile(
                          v-for="(skus_item, index) in item.skus"
                          :key="index"
                          @click.stop="handleEditCart(skus_item.skuId, 1, item)"
                        )
                          v-list-tile-title {{ skus_item.specInfo }}

        //-   .pagination-container
        //-     v-pagination(v-model="page" :length="totalPages" circle total-visible=8 @input="loadGoodsList")

    v-container(v-if='isLoading')
      Loading

</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

import Toolbar from "../../components/common/toolbar";
import Loading from "../../components/common/loading";
import goods from "../../api/goods.js";
import order from "../../api/order.js";

export default {
  data() {
    return {
      categoryList: [],
      page: 1,
      totalPages: null,
      categoryId: null,
      isLoading: true,
      plusLoading: false,
      minsLoading: false,
      checkedSpuId: null
    };
  },
  mounted() {
    this.buyerGoodsCategory();
    this.loadGoodsList();
    this.loadShoppingCart();
  },
  computed: {
    ...mapState(["shoppingCart"]),
    ...mapGetters(["goodsCartList"]),

    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("nav.home")
        },
        {
          to: { name: "shop" },
          disabled: false,
          text: this.$t("nav.series")
        }
      ];
    }
  },
  components: {
    Toolbar,
    Loading
  },
  methods: {
    ...mapActions(["loadShoppingCart"]),
    ...mapMutations(["setGoodsList"]),

    async buyerGoodsCategory() {
      try {
        const res = await goods.categoryList();
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          this.categoryList = res.data.data[0].sons[0].sons;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async loadGoodsList() {
      this.isLoading = true;
      try {
        const res = await goods.goodsSeriesList({
          page: this.page,
          //   pageLimit: 20,
          adId: this.$route.params.adId
        });
        this.isLoading = false;
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          this.setGoodsList(res.data.data.list);
          this.totalPages = res.data.data.totalPages;
        }
      } catch (e) {
        console.log(e);
      }
    },

    checkedCategory(item) {
      if (item) {
        this.categoryId = item.categoryId;
      } else {
        this.categoryId = null;
      }
      this.page = 1;
      this.loadGoodsList();
    },

    async handleEditCart(skuId, num, item) {
      this.handleCheckedGood(item);

      const payload = {
        skuId,
        num
      };
      if (num == 1) {
        this.plusLoading = true;
      } else {
        this.minsLoading = true;
      }
      try {
        const res = await order.addCart(payload);
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          await this.loadShoppingCart();
        }

        this.plusLoading = false;
        this.minsLoading = false;
      } catch (e) {
        console.log(e);
      }
    },

    handleCheckedGood(item) {
      this.checkedSpuId = item.spuId;
    },

    detail(item) {
      if (this.minsLoading && this.checkedSpuId == item.spuId) {
        return;
      } else if (this.plusLoading && this.checkedSpuId == item.spuId) {
        return;
      }
      this.$router.push({ name: "shop-detail", params: { spuId: item.spuId } });
    }
  }
};
</script>

<style scoped lang="sass" src="./shop.sass"></style>
